import React from "react";
import Card from "./Card";

interface ActivityItem {
  icon: React.ReactNode;
  title: string;
  meta: string;
}

interface RecentActivityProps {
  items: ActivityItem[];
}

const RecentActivity = ({ items }: RecentActivityProps) => {
  return (
    <Card title="Recent Activity">
      <div className="recentList">
        {items.map((item) => (
          <div className="recentItem" key={item.title}>
            <span className="recentIcon">{item.icon}</span>
            <div>
              <div className="recentTitle">{item.title}</div>
              <div className="recentMeta">{item.meta}</div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default RecentActivity;
